import Swiper from "swiper";

function initBreadcrumbsSlider() {
    const breadcrumbsSwiper = document.querySelector(".js-breadcrumbs-slider");

    if (breadcrumbsSwiper) {
        const breadcrumbsSwiperList = breadcrumbsSwiper.querySelector(
            ".js-breadcrumbs-slider-list",
        );
        const controls = breadcrumbsSwiper.querySelector(".js-breadcrumbs-controls");
        const nextBtn = controls.querySelector(".slider-button-next");
        const prevBtn = controls.querySelector(".slider-button-prev");
        const initialSlideIndex = breadcrumbsSwiperList.children.length - 1;

        const swiper = new Swiper(breadcrumbsSwiper, {
            slidesPerView: "auto",
            navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
            },
            initialSlide: initialSlideIndex,
        });

        if (nextBtn) {
            nextBtn.addEventListener("click", () => {
                swiper.slideTo(initialSlideIndex);
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener("click", () => {
                swiper.slideTo(0);
            });
        }
    }
}

window.addEventListener("load", () => {
    if (window.mobileMedia) {
        initBreadcrumbsSlider();
    }
});
